import {Injectable, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SelectionService} from '@mydocma/component-library/src/lib/selection';

@UntilDestroy()
@Injectable()
export class GridItemSelectionService extends SelectionService<any> implements OnDestroy {


  constructor() {
    super();

    this.itemSelectionChange
    .pipe(untilDestroyed(this))
    .subscribe(fi => {
      if (fi?.item) {
        fi.item.isChecked = fi.selected;
      }
    });

    // this.selectedItems
    // .pipe(untilDestroyed(this))
    // .subscribe(async i => {
    //   if(i?.length === 0 && await firstValueFrom(this.selectionMode)) {
    //     this.stopSelectionMode();
    //   }})
  }

  ngOnDestroy(): void {
  }

  toggleSelection(item: any) {
    if (item.isChecked) {
      super.deselectItem(item);
    } else {
      super.selectItem(item);
    }
  }

}
